import Phaser from 'phaser'
import { LobbyScene }        from './scenes/LobbyScene'
import { GameScene }         from './scenes/GameScene'
import { MultiplayerScene }  from './scenes/MultiplayerScene'
import { LeaderboardScene }  from './scenes/LeaderboardScene'
import { CampaignMapScene }  from './scenes/CampaignMapScene'
import { CampaignScene }     from './scenes/CampaignScene'

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 1280,
  height: 720,
  backgroundColor: '#0a0a1a',
  scene: [LobbyScene, GameScene, MultiplayerScene, LeaderboardScene, CampaignMapScene, CampaignScene],
  parent: document.body,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
}

new Phaser.Game(config)
